import * as React from 'react';
export const bankSvg = React.forwardRef(function bankSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M7.674.075a.75.75 0 0 1 .652 0l7.109 3.431a1 1 0 0 1 .565.9V6a1 1 0 0 1-1 1h-1.5v4.787l1.947.973a1 1 0 0 1 .553.895V15a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1v-1.345a1 1 0 0 1 .557-.896l1.97-.974L2.504 7H1a1 1 0 0 1-1-1V4.407a1 1 0 0 1 .565-.9L7.674.074ZM12 12.25V7h-1.5v5.25a.75.75 0 0 1-1.5 0V7H7v5.25a.75.75 0 0 1-1.5 0V7H4.004l.025 5.246a.75.75 0 0 1-.418.676L1.5 13.966v.534h13v-.537l-2.085-1.042A.75.75 0 0 1 12 12.25Zm2.5-6.75v-.78L8 1.584 1.5 4.72v.78h13Z',
    }),
  );
});
bankSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var bank = {
  category: 'icon',
  colorable: true,
  name: 'bank',
  svg: bankSvg,
};
